module.exports = __webpack_public_path__ + "img/72_28.219109ab.png";